import { Navigate } from "react-router-dom";

import { ProtectedRoute } from "components/UI";

const mainRoutes = [
  {
    path: "/",
    element: (
      <ProtectedRoute name="dashboard" isDefaultPath>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    ),
  },
];

export default mainRoutes;
